/* @flow */

import type { KeyValuePair } from '../jsHelpers/types';

const cleanLanguage: (tag: string) => string | null = (tag) => {
  try {
    return new Intl.Locale(tag).language;
  } catch {
    return null;
  }
};

/*
 * What this function does:
 *  - Removes duplicates
 *  - Removes country-specific codes (e.g. ["fr", "fr-BE"] and ["fr-CA"] both becomes ["fr"])
 *  - Converts to lower case
 *  - Preserves order
 */
const cleanLanguageList: (languages: ReadonlyArray<string>) => Array<string> = (languages) => {
  const langDic: KeyValuePair<number> = {};

  if (languages) {
    let i = 0;
    languages.forEach((l) => {
      const language = cleanLanguage(l);
      if (language !== null && typeof langDic[language] !== 'number') {
        langDic[language] = i;
        i += 1;
      }
    });
  }

  const languageList = Object.keys(langDic);
  const cleanedLanguages = Array(languageList.length);

  languageList.forEach((language) => {
    cleanedLanguages[langDic[language]] = language;
  });

  return cleanedLanguages;
};

const checkUpdatePageTitle: (language: string) => void = (language) => {
  // Find all titles in page
  document.head?.querySelectorAll('meta[name=title]').forEach((tag) => {
    if (tag instanceof HTMLMetaElement) {
      const { content, lang } = tag;

      if (lang === language && content) {
        document.title = content;
      }
    }
  });
};

export { checkUpdatePageTitle, cleanLanguage, cleanLanguageList };
